import TemplateView from '../../../TemplateView'

export default class BulkOperationProgress extends TemplateView {
    constructor() {
        super()

        this.state = {
            progress: 0
        }

        this.onStatePropertyChanged('progress', progress => this.$percent.text(`${progress} %`))
    }

    afterRender() {
        this.$percent = this.find('.percents')
    }

    templateHtml() {
        return '<div class="bulkOperationProgress">' +
               '    <span class="percents"></span>' +
               '    <span class="completedLabel"><%=completed%></span>' +
               '</div>'
    }

    messageKeys() {
        return {
            completed: 'task.list.bulk_operations.progress.completed'
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/bulkOperations/components/BulkOperationProgress.js